import actions from './actions'

// get local data
import { getLocalData } from '../../services/StorageServices'

const _getSessionKey = () => {
    const session_key = getLocalData('session_key', null)
    return session_key ? session_key : null
}

const initState = {
    session_key: _getSessionKey(),
    isLoggedIn: _getSessionKey() != null,
    userInfo: null,
    isLoading: false,
    message: '',
}

const reducer = (state = initState, action) => {
   // console.log('action : ', action)
    switch (action.type) {
        case actions.type.LOGIN:
            return {
                ...state,
                ...{
                    isLoading: true,
                },
            }

        case actions.type.LOGOUT:
            return {
                ...state,
                ...{
                    isLoggedIn: false,
                    session_key: null,
                    userInfo: null,
                    message: '',
                    isLoading: false,
                },
            }

        case actions.type.GET_USER_INFO:
            return state

        case actions.type.CHECK_SESSION:
            return state

        case actions.type.UPDATE_STATE:
            return {
                ...state,
                ...action.payload.state,
            }

        default:
            return state
    }
}

export default reducer
